export const END_POINT = {
   GET_OTP: '/gameapi/xgame/getOTP',
   LOGIN_OTP: '/gameapi/xgame/loginOTP',
   LOGIN_OPEN_ID: '/gameapi/xgame/loginOpenid',
   GENERATE_TICKET: '/gameapi/sso/generate-ticket'
}

export const LOADING_TYPE = {
   SHOW: 'SHOW',
   HIDE: 'HIDE'
}

export const LOGIN_TYPE = {
   GET_OTP: 'GET_OTP_LOGIN_TYPE',
   LOGIN_OTP: 'LOGIN_OTP_LOGIN_TYPE',
   CLEAR_USER_INFO: 'CLEAR_USER_INFO_TYPE'
}

export const STORAGE_TYPE = {
   SET_CLIENT_KEY: 'SET_CLIENT_KEY_STORAGE_TYPE',
   SET_RETURN_URL: 'SET_RETURN_URL_STORAGE_TYPE',
}